import { Component, Input } from '@angular/core';

@Component({
  selector: 'dual-segment',
  templateUrl: './dual-segment.component.html',
  styleUrls: ['./dual-segment.component.css']
})
export class DualSegmentComponent {
  @Input() primaryColor!: string; // Default primary color
  @Input() secondaryColor!: string;
  @Input() thickness!: any;
  @Input() width!: any;

  ngOnInit(){
    this.width = Number(this.width) || 48;   // default to 90 if invalid
    this.thickness = Number(this.thickness) || 3; // default to 4 if invalid
  }
}
